import React, { useEffect, useState, useContext } from "react";
import { useTable } from "react-table";
import styles from "./Scholarship.module.scss";
import Card1Icon from "../../../assets/svg/Dashboard/AUD/Card2.svg";
import Card2Icon from "../../../assets/svg/Dashboard/AUD/Card4.svg";
import Card3Icon from "../../../assets/svg/Dashboard/AUD/Card5.svg";
import StatisticIcon_4 from "../../../assets/svg/Dashboard/TopTableIcon4.svg";
import StatisticIcon_5 from "../../../assets/svg/Dashboard/TopTableIcon5.svg";
import PageArrowLeft from "../../../assets/svg/Dashboard/PageArrowLeft.svg";
import PageArrowRight from "../../../assets/svg/Dashboard/PageArrowRight.svg";
import EditQuery from "../../../assets/images/EditQuery.svg";
import QueryModal from "../QueryModal";
import { Modal, Form, InputGroup } from "react-bootstrap";
import { GetAPISavedStaticsQuery } from "../../../functions/GetAPIList";
import FilterName from "../../../components/Atoms/FilterName";
import FilterNameTab from "../../../components/Atoms/FilterNameTab";

import GetBaseUrl from "../../../functions/SetBaseUrl";
// import { GetAPISavedGraphQuery } from "../../../functions/GetAPIList";
// import { GetAPISavedStaticsQuery } from "../../../functions/GetAPIList";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import Table from "../../../components/table/customTable";
import { width } from "@mui/system";
import {
  GetAPIFilterDataByColumnName,
  GetAPISavedFilterQuery,
  GetAPISavedGraphQuery,
  GetAPIFilterDataFromReport,
} from "../../../functions/GetAPIList";

import QueryStaticsModal from "../QueryStaticsModal";
import ReportColumnModal from "../ReportColumnModal";
import comparisonStyles from "../../../pages/AUD_DashboardPrivate.module.scss";

const BaseUrl = GetBaseUrl()[0];
var token = localStorage.getItem(GetBaseUrl()[1] + "_Edu_AuthToken");

export const Scholarship = ({
  queryStructures,
  withQuery,
  selectedFilters,
  setSelectedFilters,
  filter1Name,
  filter2Name,
  comparisonMode,
  comparisonTabs,
  setActiveComparisonTab,
  selectedComparisonFilters,
}) => {
  //-----------
  const [exportOption, setExportOption] = useState("");
  const [internalFilter, setInternalFilter] = useState([]);
  const [
    selectedInternalComparisonFilters,
    setSelectedInternalComparisonFilters,
  ] = useState();

  const [selectedCard, setSelectedCard] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  //-------------
  const [selectedInternalFilters, setSelectedInternalFilters] = useState();
  const [reportColumnModal, setReportColumnModal] = useState(false);
  const [askQueryModal, setAskQueryModal] = useState(false);
  const [query, setQuery] = useState();
  const [tabIndex, setTabIndex] = useState(31);
  const [queryId, setQueryId] = useState();
  const [selectedInternalFilter, setSelectedInternalFilter] = useState(null);
  const [selectedInternalFilter2, setSelectedInternalFilter2] = useState(null);
  const [loadingTable, setLoadingTable] = useState(0);
  const [leftSelected, setLeftSelected] = useState(0);

  const [Filter1, setFilter1] = useState();
  const [Filter2, setFilter2] = useState();
  const [selectedScholarship, setSelectedScholarship] = useState("");
  const [selectedSponsor, setSelectedSponsor] = useState("");
  const [selectedScholarshipFilter, setSelectedScholarshipFilter] = useState(
    []
  );
  const [scholarships, setScholarships] = useState([]);
  const [sponsors, setSponsors] = useState([]);
  const [activePeriod, setActivePeriod] = useState(0);
  const [updateFilter, setUpdateFilter] = useState(0);
  const [refreshLists, setRefreshLists] = useState(0);
  const headerArray = [
    {
      name: "Schools and Departments",
      originalName: "school",
      visible: true,
      width: "80%",
    },
    {
      name: "Total",
      originalName: "Count",
      visible: true,
      width: "20%",
    },
  ];

  const [statistics, setStatistics] = useState([
    {
      index: 31,
      reportId: 0,
      value: 0,
      percentage: 0,
      active: false,
      icon: Card1Icon,
      title: "All Applicants",
      defaultQueryStructure: `Select 
   Count`,
    },
    //   {
    //     index: 32,
    //     reportId: 0,
    //     value: 0,
    //     percentage: 0,
    //     active: false,
    //     icon: Card2Icon,
    //     title: "Not Scholarship",
    //     defaultQueryStructure: `Select
    //  Count`,
    //   },
    {
      index: 33,
      reportId: 0,
      value: 0,
      percentage: 0,
      active: false,
      icon: Card3Icon,
      title: "Granted",
      defaultQueryStructure: `Select 
   Count`,
    },
    {
      index: 34,
      reportId: 0,
      value: 0,
      percentage: 0,
      active: false,
      icon: Card3Icon,
      title: "Not Granted",
      defaultQueryStructure: `Select 
   Count`,
    },
  ]);

  //------------------------------

  const handleChangeScholarship = (event) => {
    event.target.id === "Scholarship" &&
      setSelectedScholarship(event.target.value);
    event.target.id === "Sponsor" && setSelectedSponsor(event.target.value);

    //--------------
    let parentColumn =
      event.target.id === "Sponsor" &&
      event.target.attributes.filterColumn.value;

    event.target.id === "Sponsor" && event.target.value
      ? FillDropdown(
          selectedInternalFilter2.reportId,
          selectedInternalFilter2.columnId,
          parentColumn,
          event.target.value,
          false
        )
      : event.target.id === "Scholarship" && event.target.value
      ? console.log("")
      : event.target.id === "Scholarship" && event.target.value == 0
      ? console.log("")
      : setScholarships([]);

    event.target.id === "Scholarship" && event.target.value == 0
      ? setSelectedScholarshipFilter([
          {
            columnId: event.target.attributes.parentFilterColumn.value,
            filterValue: event.target.attributes.parentFilterValue.value,
          },
        ])
      : setSelectedScholarshipFilter(
          event.target.value && event.target.value != 0
            ? [
                {
                  columnId: event.target.attributes.filterColumn.value,
                  filterValue: event.target.value,
                },
              ]
            : []
        );
  };
  //------------------------------
  const viewQueryResult = (index, SecondaryFilter = []) => {
    const element = document.getElementById("mainCard");

    let obj = {
      queryId: index,
      Period: activePeriod,
      filterData:
        SecondaryFilter && SecondaryFilter.length > 0
          ? [...SecondaryFilter]
          : [...selectedFilters],
      optionalFilterData: [...selectedScholarshipFilter],
    };

    let updatedArray = [...statistics];

    if (obj.filterData.length) {
      axios
        .post(BaseUrl + "/Report/GetDashboardReportQueryData", obj, {
          headers: {
            Authorization: `Bearer ${token}`,
            "content-type": "application/json",
          },
        })
        .then((res) => {
          if (res.data && res.data.queryName) {
            for (var i = 0; i < updatedArray.length; i++) {
              if (updatedArray[i].index === index) {
                updatedArray[i].value = res.data.filterTotal;
                updatedArray[i].reportId = res.data.reportid ?? 0;
                updatedArray[i].percentage = res.data.percentageFilter ?? 0;

                updatedArray[i].title = res.data.queryName;
                break;
              }
            }
          } else {
            for (var i = 0; i < updatedArray.length; i++) {
              if (updatedArray[i].index === index) {
                updatedArray[i].value = 0;
                updatedArray[i].percentage = 0;
                updatedArray[i].reportId = 0;
                // updatedArray[i].title = "N/A";
                break;
              }
            }
          }
        })
        .catch((res) => {
          for (var i = 0; i < updatedArray.length; i++) {
            if (updatedArray[i].index === index) {
              updatedArray[i].value = 0;
              updatedArray[i].percentage = 0;
              updatedArray[i].reportId = 0;
              updatedArray[i].title = "N/A";
              break;
            }
          }
        })
        .finally(() => {
          setStatistics(updatedArray);
          setTimeout(() => {
            // index === 34 && element && element.click();
          }, 500);
        });
    }
  };

  //---------------------------------------------------

  useEffect(() => {
    const SavedGraphQuery = async () => {
      try {
        const data =
          [31, 32, 33, 34].indexOf(queryId) > -1
            ? await GetAPISavedStaticsQuery("AUD")
            : await GetAPISavedFilterQuery("AUD");

        for (let i = 0; i < data.length; i++) {
          const element = data[i];

          if (element.queryId === queryId) {
            setQuery({
              queryName: element.queryName,
              reportId: element.reportId,
              query: element.queryText,
              columnId: element.columnId,
            });
            break;
          } else {
            setQuery({
              queryName: "",
              reportId: 0,
              query: "",
            });
          }
        }
      } catch (error) {
        console.error("Error :", error);
      }
    };
    SavedGraphQuery();
  }, [queryId]);

  //---------------------
  useEffect(() => {
    for (let i = 0; i < statistics.length; i++) {
      const element = statistics[i].index;
      [31, 32, 33, 34].indexOf(element) > -1 && selectedInternalFilters
        ? viewQueryResult(element, selectedInternalFilters)
        : viewQueryResult(element);
    }
  }, [selectedFilters, selectedScholarshipFilter]);

  //---------------------
  useEffect(() => {
    for (let i = 0; i < statistics.length; i++) {
      const element = statistics[i].index;
      [31, 32, 33, 34].indexOf(element) > -1 &&
        selectedComparisonFilters &&
        comparisonMode &&
        comparisonTabs &&
        comparisonTabs[1].active &&
        viewQueryResult(element, selectedComparisonFilters);
    }
  }, [selectedComparisonFilters]);

  //---------------------
  useEffect(() => {
    for (let i = 0; i < statistics.length; i++) {
      const element = statistics[i].index;
      !comparisonMode && viewQueryResult(element);
    }

    !comparisonMode &&
      setActiveComparisonTab(comparisonTabs, comparisonTabs[0].title);
  }, [comparisonMode]);
  //---------------------

  useEffect(() => {
    for (let i = 0; i < statistics.length; i++) {
      const element = statistics[i].index;
      [31, 32, 33, 34].indexOf(element) > -1 &&
        viewQueryResult(element, selectedInternalFilters);
    }
  }, [selectedInternalFilters]);

  //---------------------------------------------------
  useEffect(() => {
    const SavedFilterQuery = async () => {
      try {
        const data = await GetAPISavedFilterQuery("AUD");
        for (let i = 0; i < data.length; i++) {
          data[i].queryId === 35 && setSelectedInternalFilter(data[i]);
          data[i].queryId === 36 && setSelectedInternalFilter2(data[i]);
        }
      } catch (error) {
        console.error("GetAPISavedFilterQuery :", error);
      } finally {
        setRefreshLists(Math.random(2000));
      }
    };

    SavedFilterQuery();
  }, [updateFilter]);
  //------------------------------------
  useEffect(() => {
    setSponsors([]);
    setSelectedSponsor("");
    setScholarships([]);
    setSelectedScholarship("");

    selectedInternalFilter &&
      FillDropdown(
        selectedInternalFilter && selectedInternalFilter.reportId,
        selectedInternalFilter && selectedInternalFilter.columnId,
        selectedFilters && selectedFilters[0] && selectedFilters[0].columnId,
        selectedFilters && selectedFilters[0] && selectedFilters[0].filterValue
      );
  }, [refreshLists, selectedFilters]);

  //------------------------------------
  useEffect(() => {
    setSponsors([]);
    setSelectedSponsor("");
    setScholarships([]);
    setSelectedScholarship("");

    selectedComparisonFilters &&
      comparisonMode &&
      comparisonTabs &&
      comparisonTabs[1].active &&
      selectedInternalFilter &&
      FillDropdown(
        selectedInternalFilter && selectedInternalFilter.reportId,
        selectedInternalFilter && selectedInternalFilter.columnId,
        selectedComparisonFilters &&
          selectedComparisonFilters[0] &&
          selectedComparisonFilters[0].columnId,
        selectedComparisonFilters &&
          selectedComparisonFilters[0] &&
          selectedComparisonFilters[0].filterValue
      );
  }, [selectedComparisonFilters]);
  //------------------------------------
  useEffect(() => {
    setSponsors([]);
    setSelectedSponsor("");
    setScholarships([]);
    setSelectedScholarship("");

    selectedInternalFilter &&
      FillDropdown(
        selectedInternalFilter && selectedInternalFilter.reportId,
        selectedInternalFilter && selectedInternalFilter.columnId,
        selectedInternalFilters &&
          selectedInternalFilters[0] &&
          selectedInternalFilters[0].columnId,
        selectedInternalFilters &&
          selectedInternalFilters[0] &&
          selectedInternalFilters[0].filterValue
      );
  }, [selectedInternalFilters]);
  //****************************** */
  const FillDropdown = (
    reportId,
    filterColumn,
    filterColumnId = "",
    filterValue = "",
    parent = true
  ) => {
    let url =
      filterColumnId && filterValue
        ? `/Data/GetDistinctReportColumnsByName/${reportId}/${filterColumn}/1/10000?filterColumnId=${filterColumnId}&filterValue=${filterValue}`
        : `/Data/GetDistinctReportColumnsByName/${reportId}/${filterColumn}/1/10000`;

    axios
      .get(BaseUrl + url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "content-type": "application/json",
        },
      })
      .then((res) => {
        !parent
          ? setScholarships([
              res.data.data,
              reportId,
              selectedInternalFilter2.columnId,
            ])
          : setSponsors([
              res.data.data,
              reportId,
              selectedInternalFilter.columnId,
            ]);
      })
      .catch((res) => {});
  };

  //************************************ */

  useEffect(() => {
    const SavedGraphQuery = async () => {
      try {
        const data = await GetAPISavedStaticsQuery();
        for (let i = 0; i < data.length; i++) {
          const element = data[i];

          if (element.queryId === tabIndex) {
            setQuery({
              queryName: element.queryName,
              reportId: element.reportId,
              query: element.queryText,
            });
            break;
          }
        }
      } catch (error) {
        console.error("Error By Id1 :", error);
      }
    };
    SavedGraphQuery();
  }, []);
  //----------------------------------------------------

  const formatNumber = (num) => {
    if (num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
      return num;
    }
  };

  //---------------------------------------------------
  const selectCard = (index, newValue) => {
    const updatedData = statistics.map((item) =>
      item.index === index
        ? { ...item, active: newValue }
        : { ...item, active: false }
    );
    setStatistics(updatedData);

    newValue ? setLoadingTable(index) : setLoadingTable(0);
    setIsVisible(newValue);
  };
  //---------------------------------------------------------------------
  useEffect(() => {
    setFilter1(filter1Name);
  }, [filter1Name]);

  useEffect(() => {
    setFilter2(filter2Name);
  }, [filter2Name]);

  //-------------------------------------------------------
  useEffect(() => {
    setTimeout(() => {
      const defaultObj = statistics && statistics[0];
      setSelectedCard(defaultObj);
      setQueryId(defaultObj.index);
      selectCard(defaultObj.index, !defaultObj.active);
      setLeftSelected(0);
    }, 1000);
  }, []);
  //--------------------------------
  return (
    <div className={` ${comparisonStyles.FullyContainer}`}>
      {comparisonTabs && comparisonMode && (
        <div className={`${comparisonStyles.comparisonTabsContainer} row`}>
          {comparisonTabs.map((tab, i) => {
            return (
              <div
                key={tab.title}
                className={`${comparisonStyles.tab} ${
                  tab.active ? comparisonStyles.active : ""
                } `}
                style={{ width: tab.width }}
                onClick={() =>
                  setActiveComparisonTab(comparisonTabs, tab.title)
                }
              >
                <FilterNameTab
                  filter={!i && Filter1 ? Filter1 : i && Filter2 ? Filter2 : ""}
                  filterType={
                    !i && Filter1 ? "normal" : i && Filter2 ? "comparison" : ""
                  }
                  setFilter1Name={setFilter1}
                  setFilter2Name={setFilter2}
                  setSelectedInternalFilters={setSelectedInternalFilters}
                  comparisonMode={comparisonMode}
                />
              </div>
            );
          })}
        </div>
      )}
      <div className={`${styles.container} row`}>
        <div className={`${styles.selectContainer}`}>
          <h4>Sponsor</h4>
          {withQuery && (
            <img
              src={EditQuery}
              onClick={() => {
                setReportColumnModal(true);
                setQueryId(35);
              }}
              className={`${styles["EditQuery"]}`}
              alt="EditQuery"
            />
          )}
          <Form.Select
            id="Sponsor"
            className="input-bordered field-input"
            aria-label="Default select example "
            onChange={handleChangeScholarship}
            name="scholarship_organization_name___corrected_"
            value={selectedSponsor}
            reportId={sponsors[1] && sponsors[1]}
            filterColumn={sponsors[2] && sponsors[2]}
          >
            <option value={""}>All Sponsors</option>
            {sponsors &&
              sponsors[0] &&
              sponsors[0].map((item) => {
                return (
                  item &&
                  item !== "0" && (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  )
                );
              })}
          </Form.Select>
        </div>{" "}
        <div className={`${styles.selectContainer1}`}>
          <h4>Scholarship</h4>
          {withQuery && (
            <img
              src={EditQuery}
              onClick={() => {
                setReportColumnModal(true);
                setQueryId(36);
              }}
              className={`${styles["EditQuery"]}`}
              alt="EditQuery"
            />
          )}
          <Form.Select
            id="Scholarship"
            className="input-bordered field-input"
            aria-label="Default select example "
            onChange={handleChangeScholarship}
            name="scholarship_name_api"
            value={selectedScholarship}
            reportId={scholarships[1] && scholarships[1]}
            filterColumn={scholarships[2] && scholarships[2]}
            parentFilterColumn={sponsors[2] && sponsors[2]}
            parentFilterValue={selectedSponsor}
          >
            <option value={""}>All Scholarships</option>
            {scholarships &&
              scholarships[0] &&
              scholarships[0].map((item) => {
                return (
                  item &&
                  item !== "0" && (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  )
                );
              })}
          </Form.Select>
        </div>{" "}
        {/* ------------------cardsContainerTop------------------ */}{" "}
        <div className={`${styles.containerFull}  row`}>
          <div className={`${styles.containerLeft} row`}>
            {statistics &&
              statistics.map((item, index) => {
                return (
                  <div
                    id={!index ? "mainCard" : ""}
                    key={index}
                    className={`${styles.card} ${
                      leftSelected === index ? styles.active : ""
                    }`}
                    onClick={() => {
                      selectCard(item.index, !item.active);
                      setSelectedCard(item);
                      setQueryId(item.index);
                      setLeftSelected(index);
                    }}
                  >
                    {withQuery && (
                      <img
                        src={EditQuery}
                        onClick={() => {
                          setLeftSelected(index);
                          setAskQueryModal(true);
                          setQueryId(item.index);
                        }}
                        className={`${styles["EditQuery"]}`}
                        alt="EditQuery"
                      />
                    )}
                    <img src={item.Card1Icon} />
                    <div>
                      <label className={`${styles.child} `}>{item.title}</label>
                      <h2 className={`${styles.child} `}>
                        {formatNumber(item.value)}
                      </h2>
                      <span className={`${styles.spanChild} `}>
                        {item.percentage}%
                      </span>
                    </div>
                  </div>
                );
              })}
          </div>
          <div className={`${styles.containerRight}`}>
            <Table
              comparisonTabs={comparisonTabs}
              selectedComparisonFilters={selectedComparisonFilters}
              comparisonMode={comparisonMode}
              loadingTable={loadingTable}
              tableName={"Total Applicant Scholar per Schools"}
              headerArray={headerArray}
              ActionColumn={false}
              smallTable
              privateTable
              showPaginator={false}
              defaultPerPage={10}
              setExportOption={setExportOption}
              exportOption={exportOption}
              queryId={queryId}
              setStatistics={setStatistics}
              statistics={statistics}
              selectedFilters={selectedFilters}
              setSelectedFilters={setSelectedFilters}
              askQueryModal={askQueryModal}
              internalFilter={internalFilter}
              setInternalFilter={setInternalFilter}
              selectedCard={selectedCard}
              selectedInternalComparisonFilters={
                selectedInternalComparisonFilters
              }
              selectedInternalFilters={selectedInternalFilters}
              aa={[selectedInternalFilter, selectedInternalFilter2]}
              selectedScholarship={selectedScholarship}
              selectedSponsor={selectedSponsor}
            />
          </div>
        </div>
        {/* ------------------cardsContainerTop------------------ */}
        {askQueryModal ? (
          <QueryStaticsModal
            setAskQueryModal={setAskQueryModal}
            query={query}
            setQuery={setQuery}
            queryId={queryId}
            viewQueryResult={viewQueryResult}
            setStatistics={setStatistics}
            statistics={statistics}
          />
        ) : null}
        {reportColumnModal ? (
          <ReportColumnModal
            setReportColumnModal={setReportColumnModal}
            query={query}
            setQuery={setQuery}
            queryId={queryId}
            viewQueryResult={viewQueryResult}
            setStatistics={setStatistics}
            statistics={statistics}
            setUpdateFilter={setUpdateFilter}
            updateFilter={updateFilter}
            selectedFilters={selectedFilters}
          />
        ) : null}
      </div>
    </div>
  );
};
